interface Props {
  password: string;
  visible: boolean;
}

export default function PasswordRequirements({ password, visible }: Props) {
  if (!visible) return null;

  return (
    <ul className="password-requirements">
      <li className={`password-req${password.length >= 8 ? ' password-req--met' : ''}`}>
        <span className="password-req-icon">{password.length >= 8 ? '\u2713' : '\u2022'}</span>
        At least 8 characters
      </li>
      <li className={`password-req${/[A-Z]/.test(password) ? ' password-req--met' : ''}`}>
        <span className="password-req-icon">{/[A-Z]/.test(password) ? '\u2713' : '\u2022'}</span>
        At least 1 uppercase letter
      </li>
      <li className={`password-req${/[a-z]/.test(password) ? ' password-req--met' : ''}`}>
        <span className="password-req-icon">{/[a-z]/.test(password) ? '\u2713' : '\u2022'}</span>
        At least 1 lowercase letter
      </li>
      <li className={`password-req${/[0-9]/.test(password) ? ' password-req--met' : ''}`}>
        <span className="password-req-icon">{/[0-9]/.test(password) ? '\u2713' : '\u2022'}</span>
        At least 1 number
      </li>
    </ul>
  );
}
